import {FaComments} from 'react-icons/fa'
import { useState, useContext } from 'react'
import { UserContext } from '../Context/Context'
import { sendDataChannel } from './WebRTC/Rtc'

const Chat = () => {
    const [chatMessage, setChatMessage] = (useState(''))
    const {user, setUser} = useContext(UserContext)


    return (
        <div style={{display:"flex", alignItems:'center', borderRadius:'10px'}}>
            <div className="chat">
                <div className="chat_header">
                    <FaComments size={60}></FaComments>
                    <h3 style={{fontSize:"calc(var(--fs-h3) + 85%)"}}>Chat</h3>
                </div>

                <div className="chat_body">
                    
                </div>

                <form className="chat_form" onSubmit={(e) => {
                    e.preventDefault(); 
                    insertMessageToDOM({name: user.displayName, content: chatMessage, picture: user.photoURL}, true); 
                    setChatMessage("");

                    const data = {
                        type: "chat",
                        name: user.displayName,
                        content: chatMessage,
                        picture: user.photoURL
                    }

                    sendDataChannel(data)
                }}>
                    <input type="text" value={chatMessage} className="chat_text" onChange = {(e) => {
                        setChatMessage(e.target.value)
                    }}></input>
                    <input type="submit" value='Send' className="chat_submit"></input>
                </form>
            </div>
            
        </div>
    )
}

export function insertMessageToDOM(options, isFromMe) {
        
    const messagesEl = document.querySelector('.chat_body');
    var messageBox = document.createElement('div')

    var message = document.createElement('div')
    if(isFromMe){
        message.classList.add('message', 'message_mine')
    }else {
        message.classList.add('message', 'message_theirs')
    }


    var messageName = document.createElement('div')
    messageName.classList.add('message_name')
    messageName.innerHTML = options.name
    
    var messageContent = document.createElement('div')
    messageContent.classList.add('message_bubble')
    messageContent.innerHTML = options.content


    var messagePicture = document.createElement('img')
    messagePicture.classList.add('message_img')
    messagePicture.src = options.picture

    var previous = messagesEl.childNodes[messagesEl.childNodes.length - 1] 
    
    
    if (previous != null){
        if (!previous.classList.contains('message_mine') || !isFromMe){                
            if(!isFromMe && previous.classList.contains('message_theirs')){
                var messagePlaceholder = document.createElement('div')
                messagePlaceholder.classList.add('placeholder')
                message.appendChild(messagePlaceholder);    
            }else {
                message.appendChild(messagePicture);
                messageBox.appendChild(messageName)
            }
        }
        else {
            var messagePlaceholder = document.createElement('div')
            messagePlaceholder.classList.add('placeholder')
            message.appendChild(messagePlaceholder);
        }
    }
    else {
            message.appendChild(messagePicture);
            messageBox.appendChild(messageName)
    }
    

    messageBox.appendChild(messageContent)
    message.appendChild(messageBox);
    messagesEl.appendChild(message);

    // Scroll to bottom
    messagesEl.scrollTop = messagesEl.scrollHeight - messagesEl.clientHeight;
    // <ChatMessage message={{name: "Nabs", content:"test", picture: "https://picsum.photos/30"}}/>

}

export default Chat
